/**
 * This entire JS function is being used in the following files {
 *  saving-calculator.js
 * }
 */

/**
 * Both QuantityInput && SavingItem use this function
 * @param {string} itemTitle 
 */
const dataLayerAddItem = (itemTitle) => {
    window.dataLayer.push({
        event: 'SC_Add_Item',
        SC_Item_Name: itemTitle
    });
}

/**
 * Takes the entire <saving-popup> Element
 * @param {object} elem 
 */
const dataLayerButtonsInit = (elem) => {
    const bookDemoButton = elem.querySelector('#button-book-demo');
    const earnTM6Button = elem.querySelector('#button-earn-tm6');
    const buyTM6Button = elem.querySelector('#button-buy-tm6');
    if (bookDemoButton) {
        bookDemoButton.addEventListener('click', () => {
            window.dataLayer.push({
                event: 'SC - CTA Book Demo'
            });
        })
    }
    if (earnTM6Button) {
        earnTM6Button.addEventListener('click', () => {
            window.dataLayer.push({
                event: 'SC - CTA Earn TM6'
            });
        })
    }
    if (buyTM6Button) {
        buyTM6Button.addEventListener('click', () => {
            window.dataLayer.push({
                event: 'SC - CTA Buy TM6'
            });
        })
    }
}

/**
 * 
 * @param {float} savedPrice 
 * @param {integer} totalUniqueItemCount 
 */
const dataLayerSavingsCalculator = (savedPrice, totalUniqueItemCount) => {
    window.dataLayer.push({
        event:'SC_Savings_View',
        SC_Savings_Total: savedPrice,
        SC_Item_Count: totalUniqueItemCount
    });
}

/**
 * 
 * @param {integer} step 
 */
const stepDataLayer = (step) => {
    switch (step) {
        case 1:
            window.dataLayer.push({
                event: 'SC_Start_View'
            });
            break;
        case 2:
            window.dataLayer.push({
                event: 'SC_Item_Selection_View'
            });
            break;
        case 3:
            window.dataLayer.push({
                event: 'SC_Calculate_Savings_View'
            });
            break;
        default:
            break;
    }
}

export {
    dataLayerAddItem,
    dataLayerButtonsInit,
    dataLayerSavingsCalculator,
    stepDataLayer
}